export const firstFieldList = [
	"group_name",
	"group_number",
	"claim_number",
	"patient_first_name",
	"patient_last_name",
	"date_of_service",
	"closure_ltr_date",
	"closure_sent_date",
	"total_charge",
	"payee",
	"discount",
	"savings",
	"paid"
];

export const secondFieldList = [
	"allowable",
	"copay",
	"TPA_fee",
	"other_fee",
	"net_savings",
	"percentage_savings",
	"cheque_number",
	"agreement_sent",
	"cheque_mailed",
	"cheque_received",
	"cheque_cleared",
	"reissued"
];

// --------------------------------------- paid claims -----------------

export const firstFieldPaidClaimsList_v2 = [
	"group_number",
	"group_name",
	"claim_number",
	"type",
	"is_void",
	"patient_first_name",
	"patient_last_name",
	"payee",
	"closure_ltr_date",
	"closure_sent_date",
	"date_of_service",
	"total_charge",
	"discount",
	"savings",
	"allowable",
	"copay",
	"paid",
	"TPA_fee"
];

export const secondFieldPaidClaimsList_v2 = [
	"other_fee",
	"net_savings",
	"percentage_savings",
	"cheque_number",
	"agreement_sent",
	"cheque_mailed",
	"cheque_received",
	"cheque_cleared",
	"reissued",
	"is_all_claims",
	"is_check_status_requested",
	"is_closure_letter_required",
	"is_closure_letter_completed",
	"fees_paid",
	"claim_status",
	"updated_by",
	"updated_date"
];

export const firstFieldFilterPaidClaimsList_v2 = [
	// "group_number",
	// "group_name",
	"claim_number",
	"type",
	"is_void",
	"patient_first_name",
	"patient_last_name",
	"payee",
	"closure_ltr_date",
	"closure_sent_date",
	"date_of_service",
	"total_charge",
	"discount",
	"savings",
	"allowable",
	"copay",
	"paid",
	"TPA_fee",
	"other_fee"
];

export const secondFieldFilterPaidClaimsList_v2 = [
	"net_savings",
	"percentage_savings",
	"cheque_number",
	"agreement_sent",
	"cheque_mailed",
	"cheque_received",
	"cheque_cleared",
	"reissued",
	"is_all_claims",
	"is_check_status_requested",
	"is_closure_letter_required",
	"is_closure_letter_completed",
	"fees_paid",
	"claim_status",
	"updated_by",
	"updated_date"
];

export const paidClaimsFieldListSelected = [
	"group_number",
	"group_name",
	"claim_number",
	"type",
	"is_void",
	"patient_first_name",
	"patient_last_name",
	"payee",
	"closure_ltr_date",
	"closure_sent_date",
	"date_of_service",
	"total_charge",
	"discount",
	"savings",
	"allowable",
	"copay",
	"paid",
	"TPA_fee",
	"other_fee",
	"net_savings",
	"percentage_savings",
	"cheque_number",
	"agreement_sent",
	"cheque_mailed",
	"cheque_received",
	"cheque_cleared",
	"reissued",
	"is_all_claims",
	"is_check_status_requested",
	"is_closure_letter_required",
	"is_closure_letter_completed",
	"fees_paid",
	"claim_status",
	"updated_by",
	"updated_date"
];

export const paidClaimsFieldListChecked = {
	group_number: true,
	group_name: true,
	claim_number: true,
	type: true,
	is_void: true,
	patient_first_name: true,
	patient_last_name: true,
	payee: true,
	closure_ltr_date: true,
	closure_sent_date: true,
	date_of_service: true,
	total_charge: true,
	discount: true,
	savings: true,
	allowable: true,
	copay: true,
	paid: true,
	TPA_fee: true,
	other_fee: true,
	net_savings: true,
	percentage_savings: true,
	cheque_number: true,
	agreement_sent: true,
	cheque_mailed: true,
	cheque_received: true,
	cheque_cleared: true,
	reissued: true,
	is_all_claims: true,
	is_check_status_requested: true,
	is_closure_letter_required: true,
	is_closure_letter_completed: true,
	fees_paid: true,
	claim_status: true,
	updated_by: true,
	updated_date: true
};

export const paidClaimsFieldListUnChecked = {
	group_number: false,
	group_name: false,
	claim_number: false,
	type: false,
	is_void: false,
	patient_first_name: false,
	patient_last_name: false,
	payee: false,
	closure_ltr_date: false,
	closure_sent_date: false,
	date_of_service: false,
	total_charge: false,
	discount: false,
	savings: false,
	allowable: false,
	copay: false,
	paid: false,
	TPA_fee: false,
	other_fee: false,
	net_savings: false,
	percentage_savings: false,
	cheque_number: false,
	agreement_sent: false,
	cheque_mailed: false,
	cheque_received: false,
	cheque_cleared: false,
	reissued: false,
	is_all_claims: false,
	is_check_status_requested: false,
	is_closure_letter_required: false,
	is_closure_letter_completed: false,
	fees_paid: false,
	claim_status: false,
	updated_by: false,
	updated_date: false
};

// -----------------------------  idrtrackers ------------------

export const firstFieldIDRTrackersList_v2 = [
	"cooling_off_period",
	"dispute",
	"idr_decision_summary",
	"idr_entity_name",
	"notice_of_idr_initiation_end_of_right_to_initiate",
	"notice_of_idr_initiation_received_date",
	"open_negotiation_notice_end_of_right_to_initiate_on",
	"open_negotiation_notice_received_date",
	"open_negotiation_period_ending"
];

export const secondFieldIDRTrackersList_v2 = [
	"selection_of_certified_idr_entity",
	"submission_of_offer",
	"submission_offer_amount",
	"admin_fee_date",
	"admin_fee_amount",
	"createdAt",
	"updatedAt",
	"attachment_url",
	"idr_decision_date",
	"open_negotiation_response_date"
];

export const firstFieldFilterIDRTrackersList_v2 = [
	// "group_number",
	// "group_name",
	"cooling_off_period",
	"dispute",
	"idr_decision_summary",
	"idr_entity_name",
	"notice_of_idr_initiation_end_of_right_to_initiate",
	"notice_of_idr_initiation_received_date",
	"open_negotiation_notice_end_of_right_to_initiate_on",
	"open_negotiation_notice_received_date",
	"open_negotiation_period_ending"
];

export const secondFieldFilterIDRTrackersList_v2 = [
	"selection_of_certified_idr_entity",
	"submission_of_offer",
	"submission_offer_amount",
	"admin_fee_date",
	"admin_fee_amount",
	"createdAt",
	"updatedAt",
	"attachment_url",
	"idr_decision_date",
	"open_negotiation_response_date"
];

export const idrTrackersFieldListSelected = [
	"cooling_off_period",
	"dispute",
	"idr_decision_summary",
	"idr_entity_name",
	"notice_of_idr_initiation_end_of_right_to_initiate",
	"notice_of_idr_initiation_received_date",
	"open_negotiation_notice_end_of_right_to_initiate_on",
	"open_negotiation_notice_received_date",
	"open_negotiation_period_ending",

	"selection_of_certified_idr_entity",
	"submission_of_offer",
	"submission_offer_amount",
	"admin_fee_date",
	"admin_fee_amount",
	"createdAt",
	"updatedAt",
	"idr_decision_date",
	"open_negotiation_response_date"
];

export const idrTrackersFieldListChecked = {
	cooling_off_period: true,
	dispute: true,
	idr_decision_summary: true,
	idr_entity_name: true,
	notice_of_idr_initiation_end_of_right_to_initiate: true,
	notice_of_idr_initiation_received_date: true,
	open_negotiation_notice_end_of_right_to_initiate_on: true,
	open_negotiation_notice_received_date: true,
	open_negotiation_period_ending: true,

	selection_of_certified_idr_entity: true,
	submission_of_offer: true,
	submission_offer_amount: true,
	admin_fee_date: true,
	admin_fee_amount: true,
	createdAt: true,
	updatedAt: true,
	idr_decision_date: true,
	open_negotiation_response_date: true
};
export const idrTrackersFieldListUnChecked = {
	cooling_off_period: false,
	dispute: false,
	idr_decision_summary: false,
	idr_entity_name: false,
	notice_of_idr_initiation_end_of_right_to_initiate: false,
	notice_of_idr_initiation_received_date: false,
	open_negotiation_notice_end_of_right_to_initiate_on: false,
	open_negotiation_notice_received_date: false,
	open_negotiation_period_ending: false,

	selection_of_certified_idr_entity: false,
	submission_of_offer: false,
	submission_offer_amount: false,
	admin_fee_date: false,
	admin_fee_amount: false,
	createdAt: false,
	updatedAt: false,
	idr_decision_date: false,
	open_negotiation_response_date: false
};

//  --------------------------------- appeals -------------

export const firstFieldAppealsList_v2 = ["first_appeal_received", "date_to_send_first_appeal_response"];

export const secondFieldAppealsList_v2 = ["first_appeal_response_date"];

export const firstFieldFilterAppealsList_v2 = ["first_appeal_received", "date_to_send_first_appeal_response"];
export const secondFieldFilterAppealsList_v2 = ["first_appeal_response_date"];

export const appealsFieldListSelected = [
	"first_appeal_received",
	"date_to_send_first_appeal_response",
	"first_appeal_response_date"
];

export const appealsFieldListChecked = {
	first_appeal_received: true,
	date_to_send_first_appeal_response: true,
	first_appeal_response_date: true
};
export const appealsFieldListUnChecked = {
	first_appeal_received: false,
	date_to_send_first_appeal_response: false,
	first_appeal_response_date: false
};
